import ArticleSearchTagsTable from './components/ArticleSearchTagsTable'
import AdminNavigationLayout from '../../../../../shared/Layouts/TopNavigationLayout/AdminNavifationLayout'
import TopNavigationLayoutPageContent from '../../../../../shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'

const ArticleSearchTags = () => {
  return (
    <AdminNavigationLayout>
      <TopNavigationLayoutPageContent type='default'>
        <ArticleSearchTagsTable />
      </TopNavigationLayoutPageContent>
    </AdminNavigationLayout>
  )
}

export default ArticleSearchTags
